<script>
import {
    eventGroupState
} from '@app/store/eventGroupStore.js';
import {
    projectState
} from '@app/store/projectStore.js';
import {
    historyState
} from '@app/store/historyStore.js';
export let eventIndex;
export let xPos = "center";
export let yPos = "start";
let position = yPos + xPos;
let uniqueId = `position-${eventIndex}`;

function updateEventPosition(pos){
    console.log(`Updating event at index: ${eventIndex} to position x:${pos.x}, y:${pos.y}`);
    $eventGroupState[$projectState.selected].events[eventIndex].yPos = pos.y;
    $eventGroupState[$projectState.selected].events[eventIndex].xPos = pos.x;
    $eventGroupState[$projectState.selected].events[eventIndex].xOffset = 0;
    $eventGroupState[$projectState.selected].events[eventIndex].yOffset = 0;

    historyState.insert({
        name: "update position", //action name
        eventGroup: $projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify($eventGroupState)
        }]
    });
}

// Update position when props change
$: {
    position = yPos + xPos;
    uniqueId = `position-${eventIndex}`;
}
</script>

<div class="row">
    <!-- <div class="col lh-1 pe-0">
        <label for="xOffsetRange" class="form-label">X Offset ({$eventGroupState[$projectState.selected].events[eventIndex].xOffset}px)</label>
        <input id="xOffsetRange" aria-label="X offset" on:dblclick="{() => $eventGroupState[$projectState.selected].events[eventIndex].xOffset = 0}" type="range" class="form-range" title="X Offset ({$eventGroupState[$projectState.selected].events[eventIndex].xOffset}px)" min="-100" max="100" step="1" bind:value="{$eventGroupState[$projectState.selected].events[eventIndex].xOffset}">
        <label for="yOffsetRange" class="form-label">Y Offset ({$eventGroupState[$projectState.selected].events[eventIndex].yOffset}px)</label>
        <input id="yOffsetRange" aria-label="Y offset" on:dblclick="{() => $eventGroupState[$projectState.selected].events[eventIndex].yOffset = 0}" type="range" class="form-range" title="Y Offset ({$eventGroupState[$projectState.selected].events[eventIndex].yOffset}px)" min="-100" max="100" step="1" bind:value="{$eventGroupState[$projectState.selected].events[eventIndex].yOffset}">
    </div> -->
    <div class="col-4 p-0 EventPositionInput">
        <div class="position-grid">
            <div class='position-cell' title="Position: Top Left">
                <input id="pos-top-left-{eventIndex}" aria-label="Position top left" type="radio" 
                    on:change={() => updateEventPosition({x:"start",y:"start"})} 
                    bind:group={position} name="{uniqueId}" value={'startstart'}>
                <label for="pos-top-left-{eventIndex}" class="position-box"></label>
            </div>
            <div class='position-cell' title="Position: Top Center">
                <input id="pos-top-center-{eventIndex}" aria-label="Position top center" type="radio" 
                    on:change={() => updateEventPosition({x:"center",y:"start"})} 
                    bind:group={position} name="{uniqueId}" value={'startcenter'}>
                <label for="pos-top-center-{eventIndex}" class="position-box"></label>
            </div>
            <div class='position-cell' title="Position: Top Right">
                <input id="pos-top-right-{eventIndex}" aria-label="Position top right" type="radio" 
                    on:change={() => updateEventPosition({x:"end",y:"start"})} 
                    bind:group={position} name="{uniqueId}" value={'startend'}>
                <label for="pos-top-right-{eventIndex}" class="position-box"></label>
            </div>
            <div class='position-cell' title="Position: Center Left">
                <input id="pos-center-left-{eventIndex}" aria-label="Position center left" type="radio" 
                    on:change={() => updateEventPosition({x:"start",y:"center"})} 
                    bind:group={position} name="{uniqueId}" value={'centerstart'}>
                <label for="pos-center-left-{eventIndex}" class="position-box"></label>
            </div>
            <div class='position-cell' title="Position: Center">
                <input id="pos-center-{eventIndex}" aria-label="Position center" type="radio" 
                    on:change={() => updateEventPosition({x:"center",y:"center"})} 
                    bind:group={position} name="{uniqueId}" value={'centercenter'}>
                <label for="pos-center-{eventIndex}" class="position-box"></label>
            </div>
            <div class='position-cell' title="Position: Center Right">
                <input id="pos-center-right-{eventIndex}" aria-label="Position center right" type="radio" 
                    on:change={() => updateEventPosition({x:"end",y:"center"})} 
                    bind:group={position} name="{uniqueId}" value={'centerend'}>
                <label for="pos-center-right-{eventIndex}" class="position-box"></label>
            </div>
            <div class='position-cell' title="Position: Bottom Left">
                <input id="pos-bottom-left-{eventIndex}" aria-label="Position bottom left" type="radio" 
                    on:change={() => updateEventPosition({x:"start",y:"end"})} 
                    bind:group={position} name="{uniqueId}" value={'endstart'}>
                <label for="pos-bottom-left-{eventIndex}" class="position-box"></label>
            </div>
            <div class='position-cell' title="Position: Bottom Center">
                <input id="pos-bottom-center-{eventIndex}" aria-label="Position bottom center" type="radio" 
                    on:change={() => updateEventPosition({x:"center",y:"end"})} 
                    bind:group={position} name="{uniqueId}" value={'endcenter'}>
                <label for="pos-bottom-center-{eventIndex}" class="position-box"></label>
            </div>
            <div class='position-cell' title="Position: Bottom Right">
                <input id="pos-bottom-right-{eventIndex}" aria-label="Position bottom right" type="radio" 
                    on:change={() => updateEventPosition({x:"end",y:"end"})} 
                    bind:group={position} name="{uniqueId}" value={'endend'}>
                <label for="pos-bottom-right-{eventIndex}" class="position-box"></label>
            </div>
        </div>
    </div>
</div>
<style>
    /* .EventPositionInput {
        transform: scale(1) translate(0%, 0%);
    }

    .form-range {
        height: 0.5rem;
        color: aquamarine;
    }

    .form-label {
        font-size: 10px;
        margin: 0;
    } */

    .position-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(3, 1fr);
        gap: 3px;
        width: 100%;
        min-width: 80px;
        min-height: 80px;
        aspect-ratio: 1/1;
        margin: 0 auto;
    }

    .position-cell {
        position: relative;
        width: 100%;
    }

    .position-cell input {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
    }

    .position-box {
        display: block;
        width: 100%;
        height: 100%;
        aspect-ratio: 1/1;
        background-color: #666;
        border-radius: 3px;
        cursor: pointer;
        transition: background-color 0.2s, transform 0.1s;
        min-width: 24px;
        min-height: 24px;
    }

    .position-cell input:hover + .position-box {
        background-color:  rgba(13, 110, 253, 0.2);
    }

    .position-cell input:checked + .position-box {
        background-color: rgba(13, 109, 253, 0.8);
        transform: scale(0.9);
    }

    .position-cell input:focus + .position-box {
        box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.5);
    }
</style>